import { render } from "./SuggestionBox.vue?vue&type=template&id=42c25abc&scoped=true&ts=true"
import script from "./SuggestionBox.vue?vue&type=script&lang=ts"
export * from "./SuggestionBox.vue?vue&type=script&lang=ts"

import "./SuggestionBox.vue?vue&type=style&index=0&id=42c25abc&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c25abc"]])

export default __exports__